import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { FC } from 'react';
import { ChildrenContainer, CloseButton, ModalBody, Overlay, StyledModal, Title } from './Modal.styles';
import { ModalProps } from './Modal.types';

const Modal: FC<ModalProps> = ({ open, onClose, children, hideCloseButton = false, title, id, bodyWidth, ...props }) => {
  return (
    <StyledModal open={open} onClose={onClose} BackdropComponent={Overlay} aria-describedby={`${id}-label`} {...props}>
      <ModalBody aria-modal='true' role='dialog' width={bodyWidth}>
        <Title id={`${id}-label`}>{title}</Title>
        <ChildrenContainer> {children}</ChildrenContainer>
        {hideCloseButton ? (
          <></>
        ) : (
          <CloseButton onClick={onClose} aria-label='close'>
            <CloseOutlinedIcon fontSize='inherit' color='inherit' />
          </CloseButton>
        )}
      </ModalBody>
    </StyledModal>
  );
};

export default Modal;
